

export const frontMatter = {
	sidebar_position: 30
};
export const contentTitle = 'Plain call vs method call';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-useful-tips-plain-call-vs-method-call-md-4c1.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    header: "header",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "plain-call-vs-method-call",
        children: "Plain call vs method call"
      })
    }), "\n", _jsx(_components.p, {
      children: "In most cases there are two ways of calling API functions: as a function and as a class method."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "//import for function call\nimport { flip } from 'image-js';\n\n// Method call on the image instance\nconst flipped1 = image.flip(options);\n// Equivalent plain method call\nconst flipped2 = flip(image, options);\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "There is no particular advantage using one way over another, you are free to use whichever suites your needs best."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

